import { Injectable } from '@angular/core';
import { context, isSpanContextValid, trace } from '@opentelemetry/api';
import { environment } from '../../environments/environment';
import { ENV, LOG_LEVEL, type LogLevel } from '../models/general';
import {
  SERVICE_NAME_KEY,
  ENVIRONMENT_KEY,
  SERVICE_NAME,
  SIGNOZ_INGESTION_KEY_HEADER,
  LOG_ENDPOINT,
} from '../models/signoz';

@Injectable({ providedIn: 'root' })
export class LoggerService {
  private endpoint = environment.signozUrl + LOG_ENDPOINT;
  private ingestionKey = environment.signozIngestionKey;

  log(message: string, level: LogLevel = LOG_LEVEL.INFO) {
    if (!environment.production) {
      return;
    }

    const activeSpan = trace.getSpan(context.active());
    const spanContext = activeSpan?.spanContext();
    const url = new URL(window.location.href);
    url.search = '';
    url.hash = '';
    const logAttributes = [
      {
        key: 'http.url',
        value: { stringValue: url.toString() },
      },
    ];

    const traceContextFields =
      spanContext && isSpanContextValid(spanContext)
        ? {
            traceId: spanContext.traceId,
            spanId: spanContext.spanId,
          }
        : {};

    const body = {
      resourceLogs: [
        {
          resource: {
            attributes: [
              {
                key: SERVICE_NAME_KEY,
                value: { stringValue: SERVICE_NAME },
              },
              {
                key: ENVIRONMENT_KEY,
                value: { stringValue: ENV },
              },
            ],
          },
          scopeLogs: [
            {
              logRecords: [
                {
                  timeUnixNano: (BigInt(Date.now()) * 1000000n).toString(),
                  severityText: level,
                  body: {
                    stringValue: message,
                  },
                  ...traceContextFields,
                  attributes: logAttributes,
                },
              ],
            },
          ],
        },
      ],
    };

    fetch(this.endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        [SIGNOZ_INGESTION_KEY_HEADER]: this.ingestionKey,
      },
      body: JSON.stringify(body),
    }).catch(() => {
      // avoid infinite loop if logging fails
    });
  }
}
